export default function initFooter($) {
  $('#footer-menu .menu-item > a').removeClass(
    'link-light link-opacity-50-hover text-decoration-none'
  );

  const $backToTop = $('.js-back-to-top');
  const floatingActions = document.querySelector('.floating-actions');
  const siteFooter = document.getElementById('site-footer');

  if (floatingActions && siteFooter && 'IntersectionObserver' in window) {
    const footerObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        floatingActions.classList.toggle('is-footer-visible', entry.isIntersecting);
      });
    });

    footerObserver.observe(siteFooter);
  }

  if (!$backToTop.length) {
    return;
  }

  const reducedMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  let scrollFrame = null;

  const updateBackToTop = () => {
    const isVisible = window.scrollY >= 400;

    $backToTop
      .toggleClass('is-visible', isVisible)
      .attr('aria-hidden', isVisible ? 'false' : 'true')
      .attr('tabindex', isVisible ? '0' : '-1');

    scrollFrame = null;
  };

  $(window).on('scroll.vizaAzBackToTop', () => {
    if (scrollFrame !== null) {
      return;
    }

    scrollFrame = window.requestAnimationFrame(updateBackToTop);
  });

  $backToTop.on('click', () => {
    window.scrollTo({
      top: 0,
      behavior: reducedMotionQuery.matches ? 'auto' : 'smooth',
    });
  });

  updateBackToTop();
}
